import { EHLegalPage } from '../components/EHLegalPage';
import { SEO } from '../components/SEO';

export default function PrivacyPolicyPage() {
  const metaDescription = 'Read our privacy policy to understand how we handle and protect your data at EveningHoney.';

  return (
    <>
      <SEO
        title="Privacy Policy"
        description={metaDescription}
        ogUrl="/legal/privacy-policy"
      />
      <EHLegalPage markdownPath="/legal/eh-privacy-policy.md" />
    </>
  );
}
